import AccountsActionCreator from './AccountsActionCreator';
import FavouritesActionCreator from './FavouritesActionCreator';
import UserManagementStore from '../../stores/UserManagementStore';
import envConfig from '../../../static/config';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';

/**
  SME users will now use FavouritesStore going forward, whereas retail users will continue to use the
  existing AccountsStore. This decision was made to minimize impact to the AccountStore and to
  retail by the SME LCV changes. The AccountStore was already bloated with too many responsibilities
  and adding favourites functionality had greater scope for regression.
  If the envConfig.isLcvEnabled is disabled (i.e. the feature is toggled off) then this module will
  simply export the exisiting AccountsActionCreators and that will be used for both SME and Retail.
*/

const methods = Object.getOwnPropertyNames(
  Object.getPrototypeOf(AccountsActionCreator)
).reduce((agg, curr) => {
  agg[curr] = (...args) => {
    if (!envConfig.isLcvEnabled) {
      return AccountsActionCreator[curr](...args);
    }
    if (UserManagementStore.getUserDetailsLoad() && FavouritesStore.getLoad()) {
      if (
        UserManagementStore.isSMEUser() &&
        FavouritesStore.isLargeCustomer()
      ) {
        return FavouritesActionCreator[curr](...args);
      }
      return AccountsActionCreator[curr](...args);
    }
    return FavouritesActionCreator[curr](...args);
  };
  return agg;
}, {});

export default methods;
